<template>
  <v-container class="pa-0 ma-0">
    <v-card outlined class="pa-4 ma-0" style="height: 420px">
      <!-- Title -->
      <v-container class="chart-header pa-0 ma-0">
        <v-card-text class="pa-0 ma-0 text-body-1">
          {{ $t("financialIndicators") }}
        </v-card-text>
        <v-card-text class="pa-0 ma-0 text-body-2 grey--text">
          {{ $t("achievementAndDeviationLastSixMonths") }}
        </v-card-text>
      </v-container>

      <!-- Bar Chart -->
      <apexchart type="bar" height="330" :series="series" :options="chartOptions" />
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "GroupedFinanceChart",
  data() {
    return {
      months: ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور"],

      achievedPercent: [98, 100, 99, 97, 100, 99],
      deviationPercent: [3, 2, 4, 6, 4, 5],
    };
  },
  computed: {
    series() {
      return [
        {
          name: "درصد تحقق",
          data: this.achievedPercent,
        },
        {
          name: "درصد انحراف",
          data: this.deviationPercent,
        },
      ];
    },

    chartOptions() {
      return {
        chart: {
          type: "bar",
          stacked: false,
          toolbar: { show: false },
          fontFamily: "IRANSans",
        },

        colors: ["#10B981", "#EF4444"],

        plotOptions: {
          bar: {
            columnWidth: "35%",
            borderRadius: 6,
            borderRadiusApplication: "end",
            dataLabels: {
              position: "top",
            },
          },
        },

        dataLabels: {
          enabled: false,
        },

        xaxis: {
          categories: this.months,
          axisBorder: { show: false },
          axisTicks: { show: false },
        },

        yaxis: {
          max: 100,
          labels: {
            offsetX: this.$vuetify.rtl ? -15 : 0,

            formatter: (val) => `${val}`,
          },
        },

        grid: {
          strokeDashArray: 4,
          padding: {
            left: 10,
            right: 10,
          },
        },

        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          markers: {
            radius: 4,
          },
        },

        tooltip: {
          y: {
            formatter: (val) => `${val}٪`,
          },
        },
      };
    },
  },
};
</script>

<style scoped>
.chart-header {
  margin-bottom: 12px;
}
</style>
